module.exports = __webpack_public_path__ + "static/media/Patner12.133cb48b.svg";